import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}

export const TimeIcon: FC<IconProps> = ({ className, size = 40 }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 48 48'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path d={'M35 26H23V11'} stroke={'black'} strokeWidth={'2'} />
      <path
        clipRule={'evenodd'}
        d={
          'M43 24C43 34.493 34.494 43 24 43C13.506 43 5 34.493 5 24C5 13.507 13.506 5 24 5C34.494 5 43 13.507 43 24Z'
        }
        fillRule={'evenodd'}
        stroke={'black'}
        strokeWidth={'2'}
      />
    </svg>
  )
}
